import { render, staticRenderFns } from "./CouponCampaignList.vue?vue&type=template&id=8df83b1e&scoped=true"
import script from "./CouponCampaignList.vue?vue&type=script&lang=js"
export * from "./CouponCampaignList.vue?vue&type=script&lang=js"
import style0 from "./CouponCampaignList.vue?vue&type=style&index=0&id=8df83b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df83b1e",
  null
  
)

export default component.exports